import { render, staticRenderFns } from "./SubjectDetail.vue?vue&type=template&id=70c13f70&scoped=true&"
import script from "./SubjectDetail.vue?vue&type=script&lang=js&"
export * from "./SubjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./SubjectDetail.vue?vue&type=style&index=0&id=70c13f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c13f70",
  null
  
)

export default component.exports